const ecology: { [key: number]: string } = {
  1: '捕獲',
  2: '観察',
  3: '狩猟',
  4: '目撃',
  5: '足跡',
  6: '糞便',
  7: '食痕',
  8: '掘り起こし',
  9: '錯誤捕獲',
  10:'テレメトリー',
};
// 状況情報の表示順
const ecologyDisplayOrder = [1,2,3,4,5,6,7,8,10,9];

const user: { [key: number]: string } = {
  1: 'ログイン閲覧者',
  2: '登録修正論理削除者',
  3: '管理',
};

const trapList: { [key: number]: string } = {
  1: '箱罠',
  2: 'くくり罠',
  3: '柵罠',
  4: 'その他',
  5: '銃猟',
  6: '-',
};

// 罠・捕獲表示順
const trapDisplayOrder = ["1", "2", "3", "5", "4"];

const display: { [key: number]: string } = {
  0: '公開',
  1: 'ログイン閲覧者公開',
  2: '登録修正論理削除権限者公開',
  3: '管理者公開',
};

const prevention: { [key: number]: string } = {
  1: '電気柵',
  2: 'ワイヤーメッシュ',
  3: '複合柵',
  4: 'その他',
};

const damage_category: { [key: number]: string } = {
  1: '防止施設',
  2: '農産物',
  4: '人',
  5: '生活環境',
};

const vermin_category: { [key: number]: string } = {
  1: 'イノシシ',
  2: 'クマ',
  3: 'シカ',
  4: 'サル',
  5: 'アライグマ',//231004追加
  6: 'ハクビシン',//231004追加
  7: 'その他',//240517追加
};

const category_vermin: { [key: string]: number } = {
  'イノシシ': 1,
  'クマ': 2,
  'シカ': 3,
  'サル': 4,
  'アライグマ': 5,//231004追加
  'ハクビシン': 6,//231004追加
  'その他':7,//240517追加
};

const damage_implementation: { [key: number]: string } = {
  1: '対策検討中',
  2: '対策準備中',
  3: '対策実施完了',
  4: '対策必要なし',
};

export {
  ecology,
  ecologyDisplayOrder,
  user,
  trapList,
  trapDisplayOrder,
  display,
  prevention,
  damage_category,
  vermin_category,
  damage_implementation,
  category_vermin,
}
